"use client";
import { definePhiModuleClientContributions } from "@phis/ui/module/client";
import { PHI_DEV_RUNTIME_MODULE_ID } from "./ids";
/**
 * The live Client contribution, at the fixed name the projection reads.
 *
 * The pages are drawn from first-party Widgets, so there is no Render loader of this package's own --
 * the entry exists because the Module has to be listed on both boundaries.
 */
export const phiModuleClientContributions = definePhiModuleClientContributions({
    modules: [{
            moduleId: PHI_DEV_RUNTIME_MODULE_ID,
            renderClients: [],
        }],
});
